import request from '@/assets/js/request';
import store from '@/store';
import utils from '@/assets/js/utils';

const { VUE_APP_UPLOADFILE_URL } = process.env;
const uploadFileUrl = ''; //VUE_APP_UPLOADFILE_URL;
/**
 * @description 获取用户信息
 */
export async function getUserInfo() {
    const data = await request({
        url: '/login/info',
        method: 'post'
    });
    const { state, result } = data.data;
    if (state == 1 && result) {
        store.commit('setUserInfo', result);
        store.commit('setPriviList', result.privileges);
    }
}

/**
 * @description 获取登录用户拥有的一二级菜单列表
 */
export async function getMenuList() {
    const data = await request({
        url: '/login/menuList',
        method: 'post'
    });
    const { state, result } = data.data;
    if (state == 1 && result) {
        store.commit('setMenuList', result);
    }
}

/**
 * @description 获取所有权限列表
 */

export function getPrivileges(params) {
    return request({
        url: '/adminPrivilege/list',
        method: 'post',
        data: params || { parentId: '' }
    });
}

/**
 * @description 获取所有角色
 */

export function getRoleAll() {
    return request({
        url: '/adminRole/list',
        method: 'post',
        data: {}
    });
}

/**
 * @description 上传图片
 *  @param {*} formData
 */

export function uploadImg(formData, onUploadProgress) {
    return request({
        auth: false,
        url: uploadFileUrl + '/file/upimg', //'https://dev2-uploadfile.showstart.com/file/upimg',
        method: 'post',
        data: formData,
        params: { terminal: 4 },
        onUploadProgress: onUploadProgress || function () { }
    });
}

/**
 * @description 图片上传（base64）
 * @param {*} formData
 */
export function uploadImgByBase64(formData, onUploadProgress) {
    return request({
        auth: false,
        url: uploadFileUrl + '/file/upimg64',
        method: 'post',
        // timeout: 60 * 60 * 1000,
        data: formData,
        params: { terminal: 4 },
        onUploadProgress: onUploadProgress || function () { }
    });
}

/**
 * @description 上传音频
 * @param {*} formData
 */
export function uploadAudio(formData, onUploadProgress) {
    return request({
        auth: false,
        url: uploadFileUrl + '/file/upaudio',
        method: 'post',
        // timeout: 60 * 60 * 1000,
        data: formData,
        params: { terminal: 4 },
        onUploadProgress: onUploadProgress || function () { }
    });
}

/**
 * @description 下载临时文件
 * @param {*} filePath 文件下载路径
 */
export async function downloadFileTmp(filePath, fileName) {
    const res = await request({
        auth: false,
        url: uploadFileUrl + '/file/downfiletmp',
        method: 'post',
        // timeout: 60 * 60 * 1000,
        params: { filePath: filePath, terminal: 4 },
        responseType: 'blob'
    });
    utils.exportFile(res.data, fileName);
}
export async function downloadInvoice(file) {
    const formData = new FormData();
    formData.append('file', file);
    const res = await request({
        auth: false,
        url: '/admin/invoice/record/upFile',
        method: 'post',
        data: formData
    });
    return res;
}
/**
 * @description 上传临时文件
 * @param {*} formData
 */
export function uploadFileTmp(formData, onUploadProgress) {
    return request({
        auth: false,
        url: uploadFileUrl + '/file/upfiletmp',
        method: 'post',
        // timeout: 60 * 60 * 1000,
        data: formData,
        params: { privileges: 0, terminal: 4, ownerId: 1 },
        onUploadProgress: onUploadProgress || function () { }
    });
}

/**
 * @description 上传正式文件
 * @param {*} formData
 */
export function uploadFile(formData, onUploadProgress) {
    return request({
        auth: false,
        url: uploadFileUrl + '/file/upfile',
        method: 'post',
        // timeout: 60 * 60 * 1000,
        data: formData,
        params: { privileges: 0, terminal: 4 },
        onUploadProgress: onUploadProgress || function () { }
    });
}

/**
 * @description 上传短视频
 * @param {*} formData
 */
export function uploadVideo(formData, onUploadProgress) {
    return request({
        auth: false,
        url: uploadFileUrl + '/file/upvideo',
        method: 'post',
        // timeout: 60 * 60 * 1000,
        data: formData,
        params: { privileges: 0, terminal: 4 },
        onUploadProgress: onUploadProgress || function () { }
    });
}

/**
 * @description 下载正式文件、图片等
 * @param {*} filePath 文件下载路径
 */
export async function downloadFile(filePath, fileName) {
    const res = await request({
        auth: false,
        url: uploadFileUrl + '/file/downfile',
        method: 'post',
        // timeout: 60 * 60 * 1000,
        params: { filePath: filePath, terminal: 4 },
        responseType: 'blob'
    });
    utils.exportFile(res.data, fileName);
}

/**
 * @description 获取省份
 */
export function fetchProvince() {
    return request({
        url: '/common/provinces',
        method: 'post'
    });
}

/**
 * @description 获取城市
 * @param {*} provinceCode 省份code
 */
export function fetchCityList(provinceCode) {
    return request({
        url: '/common/cityList',
        method: 'post',
        params: { provinceCode: provinceCode }
    });
}

/**
 * @description 模糊搜索城市
 * @param {String} query 查询关键字
 */
export function fuzzyQueryCity(query) {
    return request({
        url: '/common/getCityByName',
        method: 'post',
        params: { keywords: query }
    });
}

/**
 * @description 获取省份城市联级
 */
export async function fetchAllCity() {
    let res = await request({
        url: '/common/allCity',
        method: 'post'
    });
    const {
        data: { result }
    } = res;
    if (result) {
        res.data.result.map(item => {
            item.cityList.map(v => {
                v.code = v.id;
            });
            item.cityList = Array.from(item.cityList).sort((x, y) => x.id - y.id);
        });
    }
    return res;
}

/**
 * @description 查询用户（可用于查询选择）
 * @param {*} queryCount 查询个数，默认20个
 * @param {*} queryValue 查询值（用户名称或者用户id）
 * @param {*} userType 用户类型:0=不限，1=乐迷，2=艺人，3=场地，5=厂牌,-1=B类用户(艺人/场地/厂牌) 默认0
 */
export async function fetchUser(params) {
    return request({
        url: '/userInfo/query',
        method: 'post',
        data: { ...params, queryCount: 50 }
    });
}

/**
 * @description 获取风格列表
 */
export function fetchStyleList() {
    return request({
        url: '/styleTag/list',
        method: 'post'
    });
}

/**
 * @description 获取支付渠道
 */
export function fetchPayList() {
    return request({
        url: '/common/payClassifySelect',
		method: 'get'
    });
}

/**
 * @description 获取活动标签风格列表
 */
export function fetchtagStyleList(params) {
    return request({
        url: '/styleTag/list',
        method: 'post',
        params: { ...params }
    });
}


/**
 * @description 获取tag列表
 */
export function fetchTagList(styleId) {
    return request({
        url: '/styleTag/tags',
        method: 'post',
        params: { styleId: styleId }
    });
}

/**
 * @description 获取风格tag联级
 */
export function fetchAllTag() {
    return request({
        url: '/styleTag/all',
        method: 'post'
    });
}

/**
 * @description 获取所有快递公司
 */
export function fetchExpress() {
    return request({
        url: '/common/express/all',
        method: 'post'
    });
}

/**
 * @description 获取所有国家（区号）
 */
export function fetchAllCountry() {
    return request({
        url: '/common/allCountry',
        method: 'post'
    });
}

/**
 * @description 获取所有下单终端
 */
export function fetchTerminal() {
    return request({
        url: '/common/orderTerminal',
        method: 'post'
    });
}

/**
 * @description 获取第三方平台
 * @param {*} isThird  1只看三方  0仅看非三方 -1或空 查看全部
 */
export function fetchThirdAccount(params) {
    console.log(params)
    return request({
        url: '/thirdAccount/all',
        method: 'post',
        params: params
    });
}

/**
 * @description 获取银行列表
 */
export function fetchBank() {
    return request({
        url: '/common/bank/all',
        method: 'post'
    });
}

/**
 * @description 保存腾讯云上传结果
 * @param {*} bucket 文件存储桶
 * @param {*} key 文件key
 * @param {*} resourceId 资源ID
 * @param {*} signUrl 代签名访问url
 */
export function fileTask(params) {
    return request({
        url: '/video/save/tencent',
        method: 'post',
        data: { ...params }
    });
}


/**
 * @description 获取id-token
 */
export async function fetchAccessToken() {
    const res = await request({
        url: '/token/get',
        method: 'get',
    });
    const { status, result } = res.data;
    if (status == 200 && result) {
        store.commit('setAccessToken', result);
    }
    return res;
}

/**
 * @description 获取验证码开关
 */
export function verificationSwitch() {
    return request({
        url: '/common/verificationSwitch',
        method: 'post',
    });
}

/**
 * @description 搜索话题（可用于查询选择）
 * @param {*} name 话题名称	
 */
export async function fetchTopic(params) {
    return request({
        url: '/topic/search',
        method: 'post',
        params: { ...params }
    });
}


/**
 * @description 上传照片墙图片
 *  @param {*} formData
 */

export function uploadPhoto(formData, params, onUploadProgress) {
    return request({
        auth: false,
        url: uploadFileUrl + '/file/upPhoto', //'https://dev2-uploadfile.showstart.com/file/upimg',
        method: 'post',
        data: formData,
        params: { terminal: 4, ...params },
        onUploadProgress: onUploadProgress || function () { }
    });
}

/**
 * @description 获取所有积分商品类型
 */
export function fetchPointsGoodsCategory() {
    return request({
        url: '/point/goods/getGoodsCategory',
        method: 'post'
    });
}

/**
 * @description 根据名字查询代理商
 */
export function fetchAgent(keyword) {
    return request({
        url: '/agent/searchByName',
        method: 'post',
        params: { keyword: keyword }
    });
}

/**
 * @description 获取服务模板类型
 */
export function fetchServiceTemplateType() {
    return [{
        value: 1,
        label: '服务说明'
    }, {
        value: 3,
        label: '其它'
    }, {
        value: 4,
        label: '售后相关'
    }, {
        value: 6,
        label: '观演规则'
    }, {
        value: 7,
        label: '入场规则'
    } , {
        value: 9,
        label: '购票规则'
    }]
}

/**
 * @description 飞书SSO登录
 */
export async function fetchFeishuLogin() {
    const res = await request({
        url: '/login',
        method: 'POST',
        data: {}
    });
    const { state, result } = res.data;
    if (state == 1 && result) {
        store.commit('setCUSUT', result.idToken || "");
        store.commit('setUserInfo', result);
        store.commit('setPriviList', result.privileges || null);
        getMenuList();//获取登录用户拥有的菜单权限
    }
    return res;
}
